// src/pages/AuthPage.js
import React, { useState } from "react";
import { auth, db } from "../../firebaseConfig";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  sendPasswordResetEmail
} from "firebase/auth";
import { doc, getDoc, setDoc } from "firebase/firestore";
import classes from "./AuthPage.module.css";
import { useNavigate } from "react-router-dom";

const AuthPage = ({ user, defaultMode = "login" }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [reason, setReason] = useState("");
    const [username, setUsername] = useState(""); // ✅ new field
  const [isLogin, setIsLogin] = useState(defaultMode === "login");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let userCred;

      if (isLogin) {
        userCred = await signInWithEmailAndPassword(auth, email, password);
      } else {
        if (password !== confirmPassword) {
          alert("Passwords do not match!");
          return;
        }

        userCred = await createUserWithEmailAndPassword(auth, email, password);

        await setDoc(doc(db, "waitlist", userCred.user.uid), {
          uid: userCred.user.uid,
          email,
          reason,
          status: "approved",
          createdAt: new Date(),
        });

        await setDoc(doc(db, "users", userCred.user.uid), {
          uid: userCred.user.uid,
          email,
          username,
          reason,
          createdAt: new Date(),
        });
      }

      const waitlistDoc = await getDoc(doc(db, "waitlist", userCred.user.uid));
      if (!waitlistDoc.exists() || waitlistDoc.data().status !== "approved") {
        await signOut(auth);
        navigate("/waitlist", { replace: true });
        return;
      }

      navigate("/ideamap");
    } catch (err) {
      alert(err.message);
    }
  };

  const handleForgotPassword = async () => {
    if (!email) {
      alert("Please enter your email first.");
      return;
    }
    try {
      await sendPasswordResetEmail(auth, email);
      alert("Password reset email sent. Check your inbox!");
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div className={classes.authContainer}>
      <div className={classes.card}>
        {user ? (
          <>
            <h2>Welcome, {user.email}</h2>
            <button
              className={classes.button}
              onClick={() => navigate("/ideamap")}
            >
              Enter Flow State
            </button>
          </>
        ) : (
          <form onSubmit={handleSubmit} className={classes.form}>
            <h2>{isLogin ? "Login" : "Register for an account"}</h2>

            {isLogin ? null: <input
                  type="text"
                  value={username}
                  placeholder="Username"
                  onChange={(e) => setUsername(e.target.value)}
                  className={classes.input}
                  required
                />}
            
            <input
              type="email"
              value={email}
              placeholder="Email"
              onChange={(e) => setEmail(e.target.value)}
              className={classes.input}
              required
            />

            <input
              type="password"
              value={password}
              placeholder="Password"
              onChange={(e) => setPassword(e.target.value)}
              className={classes.input}
              required
            />

            {!isLogin && (
              <>
                <input
                  type="password"
                  value={confirmPassword}
                  placeholder="Confirm Password"
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className={classes.input}
                  required
                />
                <textarea
                  value={reason}
                  placeholder="What's your background?"
                  onChange={(e) => setReason(e.target.value)}
                  className={classes.textarea}
                  rows={3}
                  required
                />
              </>
            )}

            <button type="submit" className={classes.button}>
              {isLogin ? "Login" : "Register"}
            </button>

            {isLogin && (
              <p
                className={classes.forgot}
                onClick={handleForgotPassword}
              >
                Forgot Password?
              </p>
            )}

            <p
              className={classes.toggle}
              onClick={() => setIsLogin(!isLogin)}
            >
              {isLogin
                ? "Register for an account"
                : "Already have an account? Login"}
            </p>
          </form>
        )}
      </div>
    </div>
  );
};

export default AuthPage;
